import React, { useState } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import {  useUserContext } from '../../../../context/user_context/UserContext';
import { Loading } from '../../../../components/loading/Loading';
import { useOrganizationContext } from '../../../../context/organization_context/OrganizationContext';
import { IconPlus, IconTrash } from '@tabler/icons-react';
import { deleteJobCode } from '../../../../repository/JobCodeDAO';
import AddJobCodeModal from './modals/AddJobCodeModal';
import AppSidebar from '../../../../components/navbar/DesktopAppSidebar';
import { TableBody, TableCell, TableHead, TableRow, Table, Button } from '@mui/material';
import { useToast } from '../../../../context/toast/ToastContext';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../resources/strings/StringKeys';

function JobCodes() {
    const { firebaseUser } = useUserContext();
    const { organization, isOwner } = useOrganizationContext() //TODO: Replace isOwner with hasPermissions
    const [showAddJobCodeModal, setShowAddJobCodeModal] = useState(false)
    const { showToast } = useToast()
    const { t } = useTranslation();
    return (
        <>
            {organization ? (
                <>
                <AppSidebar
                    content={<Stack gap={3}>
                        <div></div>
                        <Row>
                            <Col sm><h2>{t(StringKeys.JOB_CODES)}</h2></Col>
                            {
                                isOwner ? 
                                (
                                <Col sm style={{ textAlign: "end" }}>
                                    <Button variant="contained" onClick={() => { setShowAddJobCodeModal(true) }}><IconPlus /> {t(StringKeys.ADD_CODE)}</Button>
                                </Col>                                
                                ) 
                                : 
                                (
                                    null
                                )
                            }
                        </Row>
                        <Table striped bordered hover>
                            <TableHead className="job-code-header-table">
                                <TableRow>
                                    <TableCell style={{ fontWeight: 'bold' }}>{t(StringKeys.CODE)}</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>{t(StringKeys.DESCRIPTION)}</TableCell>
                                    {
                                        isOwner ? 
                                        (
                                            <TableCell style={{ fontWeight: 'bold' }}>{t(StringKeys.DELETE)}</TableCell>
                                        ) 
                                        : 
                                        (
                                            null
                                        )
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Object.entries(organization.job_codes).map(([code, description]) => (
                                    <TableRow key={code}>
                                        <TableCell>{code}</TableCell>
                                        <TableCell>{description}</TableCell>
                                        {
                                            isOwner ? 
                                            (
                                                <TableCell>
                                                    <Button variant="danger" onClick={() => { deleteJobCode(firebaseUser.organization, code, showToast); } }>
                                                        <IconTrash color='red' />
                                                    </Button>
                                                </TableCell>
                                            ) 
                                            : 
                                            (
                                                null
                                            )
                                        }
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Stack>
                } 
                />
                    <AddJobCodeModal 
                        show={showAddJobCodeModal}
                        onHide={() => setShowAddJobCodeModal(false)}
                        />
                    </>
            ) : <AppSidebar content={<Loading />} />}
        </>
    );
}

export default JobCodes;
